// Regras PURAS do relatório de uso de Usuários (colunas da planilha e visibilidade das notificações).
// Ficam num módulo sem imports para poderem ser testadas sem navegador nem Vite (o front não tem runner de
// testes; ver backend/tests/relatorio-uso-colunas.test.ts, que importa este arquivo).

/** As notificações de uma pessoa só são visíveis ao superadmin e à própria pessoa (backend: `podeVerModulo`).
 *  Por isso a coluna "Notificações não lidas" só faz sentido para o superadmin — para o admin, a única linha
 *  com número seria a dele mesmo, no meio de uma coluna de "—". */
export const veNotificacoesDeTodos = (tipoDoUsuarioLogado?: string): boolean => tipoDoUsuarioLogado === 'superadmin';

export interface ColunaRelatorioUso { header: string; key: string }

/** Colunas da aba "Base Detalhada", na ordem; a de notificações só entra quando `incluirNotificacoes`. */
export function colunasDoRelatorioUso(incluirNotificacoes: boolean): ColunaRelatorioUso[] {
  return [
    { header: 'Nome', key: 'nome' },
    { header: 'Departamento', key: 'departamento' },
    { header: 'Empresas', key: 'empresas' },
    { header: 'Projetos', key: 'projetos' },
    { header: 'OKRs', key: 'okrs' },
    { header: 'Calendário', key: 'calendario' },
    { header: 'Anexos em projetos', key: 'cronogramas' },
    { header: 'Fluxogramas', key: 'fluxogramas' },
    { header: 'Organogramas', key: 'organogramas' },
    { header: 'Produtividade', key: 'produtividade' },
    { header: 'Último Acesso', key: 'ultimoAcesso' },
    { header: 'Dias sem Acesso', key: 'dias' },
    ...(incluirNotificacoes ? [{ header: 'Notificações Não Lidas', key: 'notificacoes' }] : []),
    { header: 'Status de Acesso', key: 'statusAcesso' },
    { header: 'Nível de Utilização', key: 'nivelUtilizacao' },
    { header: 'Observações', key: 'observacoes' },
  ];
}

const CHAVES_CENTRALIZADAS = [
  'projetos', 'okrs', 'calendario', 'cronogramas', 'fluxogramas', 'organogramas', 'produtividade', 'dias',
  'notificacoes', 'statusAcesso', 'nivelUtilizacao',
];

/** Chaves cujas colunas são centralizadas — SEM as que não existem na planilha (`getColumn` de chave
 *  inexistente quebra no ExcelJS). */
export const chavesCentralizadas = (incluirNotificacoes: boolean): string[] =>
  CHAVES_CENTRALIZADAS.filter((key) => key !== 'notificacoes' || incluirNotificacoes);
